export const isMainPlan = (plan: any) => plan ?
    (plan.isMain !== undefined || plan.isMain !== null) && plan.isMain === true
    :
    false;

export const hasMainPlan = (plans: any[]) =>
    plans.reduce((val, plan) => val ?
        true
        :
        isMainPlan(plan),
        false);
